import * as ajaxEndpoints from "../api/ajax-endpoints";
import { useQuery } from "react-query";
import { getData } from "../newApis/apiMethods";

const getLoanRejectionReasons = async () => {
  const { data } = await getData(ajaxEndpoints.REJECTION_REASONS);
  return data;
};

const useGetRejectionReasons = () => {
  return useQuery(["getLoanRejectionReasons"], getLoanRejectionReasons);
};

export default useGetRejectionReasons;
